import CustomUIImageStyle from './CustomUIImageStyle'
import PersonFavourItem from './PersonFavourItem'
import { FileReader, FileWriter } from '@/platform'

class PersonFavour {
  public BackImage: CustomUIImageStyle = new CustomUIImageStyle()
  public ExtractImage: CustomUIImageStyle = new CustomUIImageStyle()
  public ExtractName: CustomUIImageStyle = new CustomUIImageStyle()
  public FaceImageList: Array<CustomUIImageStyle> = []
  public FaceShowList: Array<CustomUIImageStyle> = []
  public FaceNameList: Array<CustomUIImageStyle> = []
  public SelectImage: CustomUIImageStyle = new CustomUIImageStyle()
  public ExtractBackImage: CustomUIImageStyle
  public ExtractDrogImage: CustomUIImageStyle
  public ExtractFavourValue: CustomUIImageStyle
  public CloseButtonImage: CustomUIImageStyle
  public MaxFaceCount: number = 0
  public FaceColumnCount: number = 0
  public RowSpacing: number = 0
  public ColumnSpacing: number = 0
  public FaceStartX: number = 0
  public FaceStartY: number = 0
  public FaceSelectX: number = 0
  public FaceSelectY: number = 0
  public FavourValueX: number = 0
  public FavourValueY: number = 0
  public FavourNameX: number = 0
  public FavourNameY: number = 0
  public FavourNameColor: string = ''
  public FavourValueColor: string = ''
  public PersonFavoutList: Array<PersonFavourItem> = []

  constructor() {
    this.BackImage = new CustomUIImageStyle()
    this.ExtractImage = new CustomUIImageStyle()
    this.ExtractName = new CustomUIImageStyle()
    this.FaceImageList = [new CustomUIImageStyle()]
    this.FaceShowList = [new CustomUIImageStyle()]
    this.FaceNameList = [new CustomUIImageStyle()]
    this.SelectImage = new CustomUIImageStyle()
    this.ExtractBackImage = new CustomUIImageStyle()
    this.ExtractDrogImage = new CustomUIImageStyle()
    this.ExtractFavourValue = new CustomUIImageStyle()
    this.CloseButtonImage = new CustomUIImageStyle()
    this.FavourNameColor = '255, 255, 0, 0'
    this.FavourValueColor = '255, 0, 0, 0'
    this.MaxFaceCount = 6
    this.FaceColumnCount = 3
    this.RowSpacing = 8
    this.ColumnSpacing = 8
    this.FaceStartX = 428
    this.FaceStartY = 36
    this.FaceSelectX = 0
    this.FaceSelectY = 0
    this.PersonFavoutList = [new PersonFavourItem()]
  }

  readBin(reader: FileReader): void {
    this.BackImage = new CustomUIImageStyle(reader)
    this.ExtractImage = new CustomUIImageStyle(reader)
    this.ExtractName = new CustomUIImageStyle(reader)
    this.FaceImageList = this.readImageStyleList(reader)
    this.FaceShowList = this.readImageStyleList(reader)
    this.FaceNameList = this.readImageStyleList(reader)
    this.SelectImage = new CustomUIImageStyle(reader)
    this.ExtractBackImage = new CustomUIImageStyle(reader)
    this.ExtractDrogImage = new CustomUIImageStyle(reader)
    this.ExtractFavourValue = new CustomUIImageStyle(reader)
    this.CloseButtonImage = new CustomUIImageStyle(reader)
    this.MaxFaceCount = reader.readInt()
    this.FaceColumnCount = reader.readInt()
    this.RowSpacing = reader.readInt()
    this.ColumnSpacing = reader.readInt()
    this.FaceStartX = reader.readInt()
    this.FaceStartY = reader.readInt()
    this.FaceSelectX = reader.readInt()
    this.FaceSelectY = reader.readInt()
    this.FavourValueX = reader.readInt()
    this.FavourValueY = reader.readInt()
    this.FavourNameX = reader.readInt()
    this.FavourNameY = reader.readInt()
    this.FavourNameColor = reader.readString()
    this.FavourValueColor = reader.readString()
    this.PersonFavoutList = []
    const n = reader.readInt()
    this.PersonFavoutList.length = n
    for (let i = 0; i < n; i++) {
      const item = new PersonFavourItem()
      item.readBin(reader)
      this.PersonFavoutList[i] = item
    }
  }

  writeBin(writer: FileWriter): void {
    this.BackImage.writeBin(writer)
    this.ExtractImage.writeBin(writer)
    this.ExtractName.writeBin(writer)
    this.writeImageStyleList(writer, this.FaceImageList)
    this.writeImageStyleList(writer, this.FaceShowList)
    this.writeImageStyleList(writer, this.FaceNameList)
    this.SelectImage.writeBin(writer)
    this.ExtractBackImage.writeBin(writer)
    this.ExtractDrogImage.writeBin(writer)
    this.ExtractFavourValue.writeBin(writer)
    this.CloseButtonImage.writeBin(writer)
    writer.writeInt(this.MaxFaceCount)
    writer.writeInt(this.FaceColumnCount)
    writer.writeInt(this.RowSpacing)
    writer.writeInt(this.ColumnSpacing)
    writer.writeInt(this.FaceStartX)
    writer.writeInt(this.FaceStartY)
    writer.writeInt(this.FaceSelectX)
    writer.writeInt(this.FaceSelectY)
    writer.writeInt(this.FavourValueX)
    writer.writeInt(this.FavourValueY)
    writer.writeInt(this.FavourNameX)
    writer.writeInt(this.FavourNameY)
    writer.writeString(this.FavourNameColor)
    writer.writeString(this.FavourValueColor)
    writer.writeInt(this.PersonFavoutList.length)
    for (let i = 0; i < this.PersonFavoutList.length; i++) {
      this.PersonFavoutList[i]!.writeBin(writer)
    }
  }

  private readImageStyleList(reader: FileReader): CustomUIImageStyle[] {
    const len = reader.readInt()
    const list: CustomUIImageStyle[] = new Array(len)
    for (let i = 0; i < len; i++) {
      list[i] = new CustomUIImageStyle(reader)
    }
    return list
  }

  private writeImageStyleList(writer: FileWriter, list: CustomUIImageStyle[]): void {
    writer.writeInt(list.length)
    for (let i = 0; i < list.length; i++) {
      list[i]!.writeBin(writer)
    }
  }
}

export default PersonFavour
